import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const username = localStorage.getItem('username');
    const role = localStorage.getItem('role');
    return role === "Admin" ? { username, role } : null;
  });
  const navigate = useNavigate();

  // Kullanıcıyı giriş yaptıran işlev
  const login = async (username, password) => {
    try {
      const response = await axios.post('https://kariyer.biyomed.net/api/auth/login', { username, password },  { withCredentials: true });
      const { role } = response.data;

      // LocalStorage'e kullanıcı bilgilerini kaydet
      localStorage.setItem('username', username);
      localStorage.setItem('role', role);

      // Kullanıcı bilgisini state'e set et
      setUser({ username, role });

      navigate('/admin'); // Başarılı giriş sonrası yönlendirme
    } catch (error) {
      console.error('Giriş hatası:', error);
      throw new Error('Giriş başarısız. Lütfen bilgilerinizi kontrol ediniz.');
    }
  };

  // Kullanıcıyı çıkış yaptıran işlev
  const logout = async () => {
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    setUser(null);
    await axios.post(
      "https://kariyer.biyomed.net/api/auth/logout", {},  { withCredentials: true }
    );
    window.location.href='/' // Çıkış sonrası yönlendirme
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// useAuth hook'u kullanarak AuthContext'e erişim sağlama
export const useAuth = () => useContext(AuthContext);
